import React from 'react';

import CurrencySelectorClickerDesktop from '../desktop/currency-selector-clicker/CurrencySelectorClicker';
import CurrencySelectorClickerMobile from '../mobile/currency-selector/CurrencySelectorClicker';
import { Calculator, CalculatorFieldName, Piwik, SiteCoreDictionary } from '../types';
import CalculatorAmountInput from './CalculatorAmountInput';

interface AmountAndCurrencyFieldMobileProps {
    calculator: Calculator;
    focusedField: CalculatorFieldName;
    onChangeAmount: (amount: number | undefined) => void;
    onClickSelectCurrency: (field: CalculatorFieldName) => void;
    setFocusedField: (calculatorFieldName: CalculatorFieldName | undefined) => void;
    currencyOnRightSide: boolean;
    piwik: Piwik | undefined;
}

export const AmountAndCurrencyFieldMobile = ({
    calculator,
    focusedField,
    onChangeAmount,
    onClickSelectCurrency,
    setFocusedField,
    currencyOnRightSide,
    piwik,
}: AmountAndCurrencyFieldMobileProps) => {
    const calculatorField = focusedField === CalculatorFieldName.FROM ? calculator.from : calculator.to;

    return (
        <div
            className={`${focusedField === CalculatorFieldName.FROM ? 'from-currency' : 'to-currency'} ${
                currencyOnRightSide ? 'currency-on-right-side' : ''
            }`}
        >
            <CurrencySelectorClickerMobile
                selectedCurrency={calculatorField.currency}
                onClick={() => onClickSelectCurrency(focusedField)}
                piwik={piwik}
            />
            <CalculatorAmountInput
                id={focusedField}
                name="select-amount"
                value={calculatorField.amount}
                onChangeAmount={onChangeAmount}
                onChangeFocus={setFocusedField}
                piwik={piwik}
            />
        </div>
    );
};

interface AmountAndCurrencyFieldDesktopProps {
    calculator: Calculator;
    focusedField: CalculatorFieldName;
    onChangeAmount: (amount: number | undefined) => void;
    setFocusedField: (calculatorFieldName: CalculatorFieldName | undefined) => void;
    onClickSelectCurrency: (field: CalculatorFieldName) => void;
    currencyOnRightSide: boolean;
    dictionary: SiteCoreDictionary;
    piwik: Piwik | undefined;
}

export const AmountAndCurrencyFieldDesktop = ({
    calculator,
    focusedField,
    onChangeAmount,
    onClickSelectCurrency,
    setFocusedField,
    currencyOnRightSide,
    dictionary,
    piwik,
}: AmountAndCurrencyFieldDesktopProps) => {
    const calculatorField = focusedField === CalculatorFieldName.FROM ? calculator.from : calculator.to;

    return (
        <div
            className={`${focusedField === CalculatorFieldName.FROM ? 'from-currency' : 'to-currency'} ${
                currencyOnRightSide ? 'currency-on-right-side' : ''
            }`}
        >
            <div className="select-currency">
                <CurrencySelectorClickerDesktop
                    selectedCurrency={calculatorField.currency}
                    onClick={() => onClickSelectCurrency(focusedField)}
                    dictionary={dictionary}
                    piwik={piwik}
                />
            </div>
            <CalculatorAmountInput
                id={focusedField}
                name="select-amount"
                value={calculatorField.amount}
                onChangeAmount={onChangeAmount}
                onChangeFocus={setFocusedField}
                piwik={piwik}
            />

            <span className="spanner" />
        </div>
    );
};
